import styled from 'styled-components';

export const StyledHeader = styled.header`
  display: flex;
  padding-left: 90px;
  padding-right: 90px;
  width: 1280px;
  margin: 0 auto;
  position: relative;
  height: 80px;
  padding-top: 0;
  padding-bottom: 0;
  justify-content: space-between;
  background-color: #ffffff;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.04),
    0 2px 6px rgba(0, 0, 0, 0.06),
    0 10px 20px rgba(0, 0, 0, 0.04);
  align-items: center;
  z-index: 5;
  box-sizing: border-box;
`;
